import React from 'react';
import { DashboardLayout } from '../components/DashboardLayout';
import { CurrencyToggle } from '../components/CurrencyToggle';
import { FixedCostsTabs } from '../components/FixedCostsTabs';
import { RecognizedSubscriptionVendorsPanel } from '../components/RecognizedSubscriptionVendorsPanel';
import { SubscriptionRebuildPanel } from '../components/admin/SubscriptionRebuildPanel';

// Entities-scope Fixed costs page (was Subscriptions): Overview, Subscriptions,
// Other fixed costs, All payees. Scoped by the global entity selector.
export function SubscriptionsPage() {
  return (
    <DashboardLayout>
      <div className="space-y-6" data-testid="subscriptions-page">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h1 className="text-3xl font-bold tracking-tight">Fixed costs</h1>
            <p className="text-muted-foreground mt-1">What the companies pay every month, measured from the bank over the last 3 full months</p>
          </div>
          <CurrencyToggle />
        </div>

        <FixedCostsTabs scope="entities" />

        {/* Matching settings: admin plumbing, kept but folded away. */}
        <details className="rounded-md border p-3" data-testid="subs-admin-settings">
          <summary className="cursor-pointer text-sm text-muted-foreground">Vendor matching settings</summary>
          <div className="mt-4 space-y-6">
            <SubscriptionRebuildPanel />
            <RecognizedSubscriptionVendorsPanel />
          </div>
        </details>
      </div>
    </DashboardLayout>
  );
}
